import { TenantStage } from './tenant';
import { TokenServices } from './token';
import { Values } from './type-utils';

export interface AccountManagementGroup {
  uuid: string;
  name: string;
  owner: string;
  description: string;
  hidden: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface AccountManagementGroupList {
  count: number;
  items: AccountManagementGroup[];
}

export interface AccountManagementPolicy {
  uuid: string;
  name: string;
  description?: string;
  tags?: string[];
  statementQuery?: string;
}

export interface AccountManagementAccountResource {
  tokenService: TokenServices;
  stage: TenantStage;
  instructorGroupUuid: string;
  participantPolicyUuid: string;
}

export const AccountManagementAdminIds: number[] = [
  1039718, 7364056, 7305701, 6057183, 7322348, 15384, 7344670, 7380272, 7328481, 2794326, 20318, 3073584, 28432, 31188, 7372961, 7384921,
  6263, 12383, 7346871, 4631, 7470355, 7358236, 7314770, 16035, 22726, 7375801, 7315452, 1128463, 48604, 7354189, 7327910, 7478821, 7462451,
  7383435, 7358041, 7445029, 47694, 7348164, 7487213, 31403, 7414239, 7359998, 7327880, 7341475, 7337038, 7464583, 2691788, 51696, 7349712,
  7473700, 7367875, 7321737, 7457982, 51692, 7333511, 7347492, 7474234, 7357128, 7418544, 7322347, 30951, 2742849, 7310036, 7357309,
  7384081, 7358960, 1562754, 7344671, 2942, 7313878, 7377331, 34602, 7364005, 7342433, 7470067, 7481977, 7342431, 7362627, 11340, 47752,
  7364949, 45643, 7317932, 21966, 47673, 2967651, 7358963, 7431338, 15391, 19947, 21667, 28087, 7315318, 7319709, 7380874, 7365289,
];

export const AccountManagementAccountUuids = {
  Labs1: '65458478-ab94-4669-b798-108436f8d65e',
  Labs2: 'e512214f-25c5-456a-a53c-d3addde4ed09',
  Certifications: 'a562b172-0b1a-447d-a025-3e216e9cd7a5',
  Partner: '562d75aa-9e4c-405d-93cf-17c779826467',
  Hardening: 'f02d2eb1-d9c3-4aa4-811f-87bf0f617f73',
};
export type AccountManagementAccountUuids = Values<typeof AccountManagementAccountUuids>;

export const AccountManagementAccountUuidToResource: { [accountUuid: string]: AccountManagementAccountResource } = {
  [AccountManagementAccountUuids.Labs1]: {
    tokenService: TokenServices.AccountManagementAutomationLabs1Prod,
    stage: TenantStage.Production,
    instructorGroupUuid: 'd8df2661-1bf8-427d-ba2f-013f1ea7a934',
    participantPolicyUuid: '6eaa9fdb-1219-4ce7-b512-d0aafa2baf92',
  },
  [AccountManagementAccountUuids.Hardening]: {
    tokenService: TokenServices.AccountManagementAutomationStg,
    stage: TenantStage.Hardening,
    instructorGroupUuid: '4cd70b21-9e68-46c1-b14b-fa700c26202d',
    participantPolicyUuid: 'c63d3dee-761e-4ea4-a6a1-e5febe12a6c7',
  },
  [AccountManagementAccountUuids.Labs2]: {
    tokenService: TokenServices.AccountManagementAutomationLabs2Prod,
    stage: TenantStage.Production,
    instructorGroupUuid: '58b01d11-3b32-4249-89f6-f3b51d713a9a',
    participantPolicyUuid: '45d79409-a2c9-4865-b02d-d754f312030e',
  },
  [AccountManagementAccountUuids.Certifications]: {
    tokenService: TokenServices.AccountManagementAutomationCertificationsProd,
    stage: TenantStage.Production,
    instructorGroupUuid: 'aa9d1d45-f67b-4ea5-a63c-a369808dd250',
    participantPolicyUuid: 'a59fd467-79c1-4bb5-a351-dba8b3d5eb8c',
  },
  [AccountManagementAccountUuids.Partner]: {
    tokenService: TokenServices.AccountManagementAutomationPartnerProd,
    stage: TenantStage.Production,
    instructorGroupUuid: '99e254fd-a2a9-4ae8-8d49-74152c183c05',
    participantPolicyUuid: '37c335b5-cfd1-4b24-a970-44f19191029e',
  },
};
